import ChartInteractions from "../../../../configurator/js/lib/chart";
import {resolvePromise} from "../../../../configurator/js/lib/Util";

export default class ProductPrinter {

  get url() {
    return this.$el.dataset.printUrl
  }

  fetchUrl() {
    return `${this.url}`
  }

  get container() {
    return document.getElementById('print')
  }

  getProductId(target) {
    if (!this.isButtonElement(target)) {
      return target.closest('button').dataset.product
    } else {
      return target.dataset.product
    }
  }

  async printOnClick(event) {
    event.preventDefault()

    // prevent doubleclicks
    if (event.detail === 2) return

    this.print(this.getProductId(event.target)).then(() => {
      setTimeout(async () => {
        await this.waitUntilImagesArePresent(async () => {
            await resolvePromise(ChartInteractions.printImages())
            window.print()
          }
        )
      }, 0)
    })

  }

  isButtonElement(target) {
    return target instanceof HTMLButtonElement
  }

  async print() {
    this.removeOldTemplate()

    let [template, error] = await resolvePromise(fetch(this.fetchUrl()))

    if (!error) {
      if (template.ok) {
        template = await template.text()
        await document.body.insertAdjacentHTML('beforeend', template);
      } else {
        return Promise.reject('Bad request for template')
      }
    }
  }

  removeOldTemplate() {
    const oldTemplate = document.getElementById('printDocument')
    if (oldTemplate) oldTemplate.remove()
  }

  areImagesLoaded() {
    const printDoc = document.getElementById('printDocument')
    if (!printDoc) return false

    const images = printDoc.querySelectorAll('img')

    for (const image of images) {
      if (!this.imageIsCompleteLoaded(image)) return false
    }

    return true
  }

  imageIsCompleteLoaded(image) {
    return image.complete && image.naturalHeight > 0
  }

  async waitUntilImagesArePresent(callback, attempt) {

    const maxAttempts = 20;

    if (!attempt) {
      attempt = 0
    }

    if (!this.areImagesLoaded()) {
      attempt++;

      if (attempt <= maxAttempts) {
        setTimeout(() => this.waitUntilImagesArePresent(callback, attempt), 10);
      }

      return;
    }

    callback();
  }

}
